import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DialogDriver, dialogDriverFactory } from '../Dialog/Dialog.driver';
import { InputDialogDataHooks } from './types';
import { buttonDriverFactory } from '../Button/Button.driver';

export interface InputDialogDriver extends DialogDriver {
  clickPrimaryButton(): Promise<void>;
  clickSecondaryButton(): Promise<void>;
  isPrimaryButtonDisabled(): Promise<boolean>;
  isSecondaryButtonDisabled(): Promise<boolean>;
}

export const inputDialogDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): InputDialogDriver => {
  return {
    ...dialogDriverFactory(base, body),
    clickPrimaryButton: () =>
      base.$(`[data-hook=${InputDialogDataHooks.PrimaryButton}]`).click(),
    clickSecondaryButton: () =>
      base.$(`[data-hook=${InputDialogDataHooks.SecondaryButton}]`).click(),
    isPrimaryButtonDisabled: () =>
      buttonDriverFactory(
        base.$(`[data-hook=${InputDialogDataHooks.PrimaryButton}]`),
      ).isButtonDisabled(),
    isSecondaryButtonDisabled: () =>
      buttonDriverFactory(
        base.$(`[data-hook=${InputDialogDataHooks.SecondaryButton}]`),
      ).isButtonDisabled(),
  };
};
